import { Box, Stack, Chip, Button, Typography } from "@mui/material";
import { useEffect, useState, useRef } from 'react';
import ExpandLessIcon from '@mui/icons-material/ExpandLess';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';

export function TextSearchTags({ startIndex, limitTags, values, getValueLabel, getTagProps, onClose, onOpen }) {
    const [isExpandClick, setIsExpandClick] = useState(false);
    const [isExpanded, setIsExpanded] = useState(false);

    const stackRef = useRef(null);
    const expandButtonRef = useRef(null);

    const tagsCount = values.length - startIndex;
    const displayedTags = isExpanded ? tagsCount : limitTags;
    const remainsTabs = tagsCount - displayedTags;

    const radius = '18px';

    useEffect(() => {
        const handleClickOutside = (event) => {
            const isStack = stackRef.current && stackRef.current.contains(event.target);
            if (isExpanded && !isStack && !isExpandClick) {
                setIsExpanded(false);
                onClose && onClose();
            }
            if (isExpandClick) {
                setIsExpandClick(false);
            }
        };
        document.addEventListener('click', handleClickOutside);
        return () => {
            document.removeEventListener('click', handleClickOutside);
        };
    }, [isExpanded, isExpandClick]);

    const setExpandState = (value, isExpandButton) => {
        setIsExpanded(value);
        if (isExpandButton) {
            setIsExpandClick(true);
        }
        if (value) {
            onOpen && onOpen();
        } else {
            onClose && onClose();
        }
    }

    const renderTags = () => {
        const endIndex = startIndex + Math.min(displayedTags, tagsCount);
        return (
            values.slice(startIndex, endIndex).map((value, index) => (
                <Chip
                    key={index}
                    {...getTagProps({ index: index + startIndex })}
                    sx={{
                        overflow: 'hidden',
                        whiteSpace: 'nowrap',
                        textOverflow: 'ellipsis',
                        width: '100%',
                        '& .MuiChip-deleteIcon': {
                            marginLeft: 'auto',
                        },
                    }}
                    label={getValueLabel(value)}
                    color="primary"
                    variant="outlined"
                />
            ))
        )
    };

    return (
        <Box sx={{ width: '100%', borderRadius: radius, borderColor: '#DDDDDD' }}>
            {tagsCount > 0 && (
                <Stack direction="row" >
                    <Stack
                        ref={stackRef}
                        sx={{
                            p: 0.5, width: '100%', minWidth: '30px',
                            cursor: (!isExpanded ? 'pointer' : ''),
                        }}
                        direction="column"
                        alignItems='start'
                        onClick={() => setExpandState(true, false)}
                    >
                        {renderTags()}
                        {remainsTabs > 0 && (
                            <Button
                                sx={{ borderRadius: radius, minWidth: '32px', height: '32px' }}
                                onClick={() => isExpanded ?? setExpandState(true, true)}
                            >
                                <Typography variant={'body1'}> {`+${remainsTabs}`} </Typography>
                            </Button>
                        )}
                    </Stack>
                    <Button
                        ref={expandButtonRef}
                        sx={{
                            width: '30px', minWidth: '30px',
                            borderTopRightRadius: radius,
                            borderBottomRightRadius: radius
                        }}
                        onClick={() => setExpandState(!isExpanded, true)}
                    >
                        {tagsCount === 1
                            ? <></>
                            : isExpanded
                                ? <ExpandLessIcon sx={{ width: '30px' }} />
                                : <ExpandMoreIcon sx={{ width: '30px' }} />
                        }
                    </Button>
                </Stack>
            )}
        </Box>
    );
}
